export type DashboardHeroMode = "associate" | "operational" | "neutral";

export interface DashboardHeroProps {
  mode?: DashboardHeroMode;
  roleLabel?: string;
  memberName?: string | null;
  contextLine?: string | null;
}

export function DashboardHero({
  mode = "associate",
  roleLabel,
  memberName,
  contextLine,
}: DashboardHeroProps) {
  if (mode === "neutral") {
    return (
      <section className="dashboard__hero dashboard__hero--neutral" aria-labelledby="dashboard-title">
        <div className="dashboard__hero-copy">
          <p className="dashboard__eyebrow">Portal do Associado</p>
          <h1 id="dashboard-title">Início</h1>
          <p className="dashboard__welcome">
            Identificando suas permissões e serviços disponíveis…
          </p>
        </div>
      </section>
    );
  }

  if (mode === "operational") {
    return (
      <section className="dashboard__hero dashboard__hero--operational" aria-labelledby="dashboard-title">
        <div className="dashboard__hero-copy">
          <p className="dashboard__eyebrow">Área institucional</p>
          <h1 id="dashboard-title">{roleLabel || "Gestão institucional"}</h1>
          <p className="dashboard__welcome">
            {contextLine || "Painel de trabalho e ferramentas operacionais liberadas para sua função."}
          </p>
        </div>
      </section>
    );
  }

  const welcomeHeading = memberName ? `Bem-vindo, ${memberName}` : "Bem-vindo ao Portal do Associado";
  const welcomeDescription =
    contextLine || "Consulte sua identificação, sua situação e os serviços disponíveis.";

  return (
    <section className="dashboard__hero dashboard__hero--associate" aria-labelledby="dashboard-title">
      <div className="dashboard__hero-copy">
        <p className="dashboard__eyebrow">
          Portal do Associado · <span className="dashboard__role-badge">{roleLabel || "Associado"}</span>
        </p>
        <h1 id="dashboard-title">{welcomeHeading}</h1>
        <p className="dashboard__welcome">{welcomeDescription}</p>
      </div>
    </section>
  );
}
